<h3 class="text-capitalize" mat-dialog-title>{{ data.isNew ? 'Add' : 'Edit' }} {{ data.type }} {{ categoryLevel }}</h3>

<mat-dialog-content>
    <form [formGroup]="form">
        <div class="form-group">
            <label>
                {{ categoryLevel }} {{ 'Name' }}
            </label>
            <input class="form-control"
                   formControlName="categoryName"
                   required
                   type="text"/>
            <app-field-error-display class="text-left" [control]="isFieldValid('categoryName')"></app-field-error-display>
        </div>
        <div class="form-group">
            <label>
                {{ 'Nest Under Parent' }}
            </label>
            <mat-form-field
                appearance="outline"
                [ngClass]="{
                    'w-100': true,
                    'bg-disabled': data.category?.children?.length > 0,
                    'bg-white': data.category?.children?.length <= 0
                }">
                <mat-select formControlName="parentCategoryId">
                    <mat-option [value]="0">{{ 'None (Top-Level)' }}</mat-option>
                    <mat-option [attr.aria-label]="parentCategory.name" *ngFor="let parentCategory of parentCategories; trackBy: trackById" [value]="parentCategory.id">
                        {{ parentCategory.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <app-field-error-display class="text-left" [control]="isFieldValid('parentCategoryId')"></app-field-error-display>
            <div *ngIf="data.category?.children?.length > 0" class="text-sm-left text-muted mt-1">{{ '* A category with subcategories must be top-level' }}</div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <label>
                    Starting Balance
                </label>
                <div class="balance-input">
                    <lf-currency [showSymbol]="true"
                                 formControlName="startingBalance"
                                 validateDecimal></lf-currency>
                </div>
                <lf-control-messages [control]="form.controls['startingBalance']"></lf-control-messages>
            </div>
            <div class="col-md-6 form-group">
                <label>
                    Balance as of
                </label>

                <input
                    (click)="asOfDate.open()"
                    [matDatepicker]="asOfDate"
                    class="form-control date d-inline-block"
                    color="accent"
                    formControlName="asOf"
                    placeholder="Start date..."
                />
                <mat-datepicker #asOfDate></mat-datepicker>
                <lf-control-messages [control]="form.controls['asOf']"></lf-control-messages>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="close(null)"
            class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="onSubmit()" [disabled]="submitInFlight" class="btn btn-primary">
        <span *ngIf="!data.isNew; else add">Update</span>
        <ng-template #add>Add</ng-template>
    </button>
</mat-dialog-actions>

